/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Search_Session_FreeInputs */

const en_us2_search_session_free = /** @type {(inputs: Search_Session_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free workout`)
};

const pt_br2_search_session_free = /** @type {(inputs: Search_Session_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Treino livre`)
};

const es_419_search_session_free = /** @type {(inputs: Search_Session_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entrenamiento libre`)
};

const pt_pt2_search_session_free = /** @type {(inputs: Search_Session_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Treino livre`)
};

const fr_fr2_search_session_free = /** @type {(inputs: Search_Session_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Séance libre`)
};

const de_de2_search_session_free = /** @type {(inputs: Search_Session_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Freies Training`)
};

const it_it2_search_session_free = /** @type {(inputs: Search_Session_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Allenamento libero`)
};

/**
* | output |
* | --- |
* | "Free workout" |
*
* @param {Search_Session_FreeInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const search_session_free = /** @type {((inputs?: Search_Session_FreeInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_Session_FreeInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_search_session_free(inputs)
	if (locale === "es-419") return es_419_search_session_free(inputs)
	if (locale === "pt-PT") return pt_pt2_search_session_free(inputs)
	if (locale === "fr-FR") return fr_fr2_search_session_free(inputs)
	if (locale === "de-DE") return de_de2_search_session_free(inputs)
	if (locale === "it-IT") return it_it2_search_session_free(inputs)
	return en_us2_search_session_free(inputs)
});
export { search_session_free as "search.session_free" }